import { useCardHookContext } from '../internal/useCardHookContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function withContextProvider(context, useContextValue) {
  return CardRenderer => {
    if (!context || !useContextValue) {
      if (context || useContextValue) {
        console.error('You must supply both context and useContextValue arguments to buildCrmCard in order to use card context.');
      }
      return CardRenderer;
    }
    return function CardWithResolvedContext(props) {
      const cardHookContext = useCardHookContext();
      const contextValue = useContextValue(props, cardHookContext);
      return /*#__PURE__*/_jsx(context.Provider, {
        value: contextValue,
        children: /*#__PURE__*/_jsx(CardRenderer, Object.assign({}, props))
      });
    };
  };
}